import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Plane } from "lucide-react";
import useBrand, { BrandMark } from "@/hooks/useBrand";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const brand = useBrand();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("gg_token", data.token);
      if (data.email) localStorage.setItem("gg_email", data.email);
      toast.success("Login berhasil");
      nav("/", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Gagal login");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen brand-hero flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <BrandMark brand={brand} size={52} />
          <div>
            <div className="font-extrabold text-2xl tracking-tight text-slate-900">{brand.company_name || "Gogojalan"}</div>
            <div className="text-xs text-slate-500">Travel Agent Dashboard</div>
          </div>
        </div>

        <div className="paper p-8">
          <h1 className="text-2xl font-bold text-slate-900 mb-1">Selamat datang kembali</h1>
          <p className="text-sm text-slate-500 mb-6">Masuk untuk mengelola invoice, e-ticket, dan booking OTA.</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label>Email</Label>
              <Input
                data-testid="login-email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@gogojalan.id"
                required
              />
            </div>
            <div>
              <div className="flex items-center justify-between">
                <Label>Password</Label>
                <Link
                  to="/forgot-password"
                  data-testid="login-forgot-link"
                  className="text-xs text-[#556b2f] hover:underline font-medium"
                >
                  Lupa password?
                </Link>
              </div>
              <Input
                data-testid="login-password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            <Button
              data-testid="login-submit"
              type="submit"
              disabled={busy}
              className="w-full bg-[#556b2f] hover:bg-[#3d4d1e] h-11 text-base"
            >
              {busy ? "Memproses..." : "Masuk"}
            </Button>
          </form>

          <div className="mt-6 text-[11px] text-slate-400 flex items-center gap-2">
            <Plane size={12} /> Masuk dengan email admin yang terdaftar
          </div>
        </div>
      </div>
    </div>
  );
}
